<div class="submission-card" [class.submission-card--expanded]="expanded">
  <!-- Header row: checkmark + submitted-at text -->
  <div
    class="submission-header"
    [class.submission-header--collapsible]="!expanded"
    (click)="!expanded && panel.toggle()">
    <mat-icon class="check-icon">check_box</mat-icon>
    <span class="submission-date">{{
      'general.notifications.submitted-at-date-by-user'
        | translate
          : {
              DATE: registration.submittedTimestamp | date: 'dd MMMM yyyy',
              TIME: registration.submittedTimestamp | date: 'HH:mm',
              FIRSTNAME: registration.submittedBy.firstname,
              LASTNAME: registration.submittedBy.lastname,
            }
        | capitalize
    }}</span>
    @if (!expanded) {
      <span class="fill"></span>
      <mat-icon class="chevron-icon" [class.chevron-open]="panelOpen">expand_more</mat-icon>
    }
  </div>

  <!-- Collapsible body (always open when expanded=true) -->
  <mat-expansion-panel
    #panel
    class="submission-panel"
    [expanded]="expanded"
    [hideToggle]="true"
    [disabled]="expanded"
    (opened)="panelOpen = true"
    (closed)="panelOpen = false">
    <mat-expansion-panel-header class="hidden-header"></mat-expansion-panel-header>

    <div class="submission-body">
      <!-- INGELEVERDE REGISTRATIES -->
      <p class="meta-label">{{ 'case.tasks.submitted-registrations' | translate | capitalize }}</p>
      @if (registration.functionRegistrations.length < 1) {
        <p class="meta-empty">
          <i>{{ 'case.tasks.nothing-submitted' | translate | capitalize }}.</i>
        </p>
      } @else {
        @for (funcReg of registration.functionRegistrations; track funcReg) {
          <div class="func-row" (click)="viewRegistration.emit(funcReg)">
            <mat-icon class="func-icon">insert_drive_file</mat-icon>
            <span class="func-title">{{ funcReg.function.title }}</span>
            <span class="fill"></span>
            @if (funcReg.loading) {
              <mat-spinner diameter="22"></mat-spinner>
            } @else {
              <mat-icon class="visibility-icon" color="primary">visibility</mat-icon>
            }
          </div>
        }
      }

      <!-- OPMERKINGEN -->
      <p class="meta-label">{{ 'general.words.comments' | translate | capitalize }}</p>
      @if (registration.comments) {
        <p class="meta-value">{{ registration.comments }}</p>
      } @else {
        <p class="meta-value meta-empty">-</p>
      }

      <!-- BEOORDELING -->
      <p class="meta-label">{{ 'general.words.rating' | translate | capitalize }}</p>
      @if (!task.toRate) {
        <p class="meta-value meta-muted">{{ 'case.tasks.no-rating-needed' | translate | capitalize }}</p>
      }
      @if (task.toRate) {
        @if (!registration.caseRatingRegistration) {
          <p class="meta-value meta-muted">
            <i>{{ 'case.tasks.no-rating-yet' | translate | capitalize }}</i>
          </p>
        } @else {
          <div class="rating-badge">{{ registration.caseRatingRegistration.caseRating.name }}</div>
          <p class="meta-small">
            {{
              'case.tasks.rated-at-date-by-user'
                | translate
                  : {
                      DATE: registration.caseRatingRegistration.registeredOn | date: 'dd MMMM yyyy',
                      TIME: registration.caseRatingRegistration.registeredOn | date: 'HH:mm',
                      FIRSTNAME: registration.caseRatingRegistration.registeredBy.firstname,
                      LASTNAME: registration.caseRatingRegistration.registeredBy.lastname,
                    }
                | capitalize
            }}
          </p>
          @if (registration.caseRatingRegistration.comments) {
            <p class="meta-value">{{ registration.caseRatingRegistration.comments }}</p>
          } @else {
            <p class="meta-value meta-empty">-</p>
          }
        }
      }
    </div>
  </mat-expansion-panel>
</div>
